// External
import React from 'react';

const Email = ({ src }) => {
    return <img alt='email' src={src} />;
};

export default Email;
